import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetUsers } from '../../store/thunk/setGetUsers';
import TableCasino from '../../../../../@casino/ui/table';
import { columns, CURRENCY_LIST, getRows, GROUPS_CASHIERS_LIST } from './helpers';
import Title from '../../../../../@casino/ui/title';
import { makeStyles, Switch } from '@material-ui/core';
import { useForm, useWatch } from 'react-hook-form';
import { setGetUsersInCsv } from '../../store/thunk/setGetUsersInCsv';
import CheckboxSwitch from '../../components/CheckboxSwitch';
import FieldInput from '../../../../../@casino/ui/Fields/Input';
import FieldsDatePicker from '../../../../../@casino/ui/Fields/DatePicker';
import FieldSelect from '../../../../../@casino/ui/Fields/Select';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        paddingTop: 0
    },
    wrapBlock: {
        padding: 20,
        background: '#1b2039',
        borderRadius: 8,
        marginBottom: 12,
    },
    loginGamer: {
        padding: 10,
        background: '#141b33',

        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        width: 'calc(100% - 20px)'
    },
}))

const UserList = () => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            stream: '',
            login: '',
            phone: '',
            email: '',
            orderBy: 'id,desc'
        }
    })
    const view = useSelector(state => state.auth.admin);
    const is_deposit = useWatch({
        control,
        name: 'is_deposit'
    })
    React.useEffect(() => {
        if (view?.login && view?.role !== 'support') {
            dispatch(setGetUsers({
                page: 1,
                rowsPerPage: 10,
                orderBy: `id,desc`
            }));
        }
    }, [view]);

    const onSubmit = (store) => {
        if (store.groups_cashiers || store.currency || store.login || store.email || store.stream || store.phone || store.referral || store.count_deposit || store.sum_deposit || store.from_date || store.to_date || store.utm_source || store.utm_content || store.utm_medium || store.utm_term || store.utm_campaign) {
            dispatch(setGetUsers({
                page: 1,
                rowsPerPage: 10,
                login: store.login,
                stream: store.stream,
                email: store.email,
                phone: store.phone,
                referral: store.referral?.toLowerCase(),
                from_date: store.from_date,
                to_date: store.from_date,
                count_deposit: store.is_deposit ? store.count_deposit : undefined,
                sum_deposit: store.is_deposit ? store.sum_deposit : undefined,
                utm_source: store.utm_source,
                utm_content: store.utm_content,
                utm_medium: store.utm_medium,
                utm_term: store.utm_term,
                utm_campaign: store.utm_campaign,
                currency: store.currency,
                groups_cashiers: store.groups_cashiers,
                orderBy: store.orderBy
            }))
        }

    }

    const users = useSelector(state => state.users.list);
    const rows = React.useMemo(() => getRows(users.data), [users]);

    const [email, login, stream, phone, referral, count_deposit, sum_deposit, from_date, to_date, utm_source, utm_content, utm_medium, utm_term, utm_campaign, currency, groups_cashiers, orderBy] = useWatch({
        control,
        name: ['email', 'login', 'stream', 'phone', 'referral', 'count_deposit', 'sum_deposit', 'from_date', 'to_date', 'utm_source', 'utm_content', 'utm_medium', 'utm_term', 'utm_campaign', 'currency', 'groups_cashiers', 'orderBy']
    })

    
    return (
        <div className={classes.root}>
            <Title label="Список игроков" />
            <form onSubmit={handleSubmit(onSubmit)} className={classes.wrapBlock} style={{ padding: 20, display: 'flex', gap: 20, flexDirection: 'column' }}>
                <div style={{ display: 'flex', columnGap: 20 }}>
                    <FieldInput
                        name="login"
                        placeholder="Поиск по логину"
                        register={register}
                    />

                    {
                        view?.role !== 'support' && (
                            <FieldInput
                                name="phone"
                                placeholder="Поиск по номеру телефона"
                                register={register}
                            />
                        )
                    }
                    <FieldInput
                        name="email"
                        placeholder="Поиск по email"
                        register={register}
                    />
                    <FieldInput
                        name="stream"
                        placeholder="Поиск по stream"
                        register={register}
                    />
                    {
                        view?.role !== 'support' && (
                            <FieldInput
                                name="referral"
                                placeholder="Поиск по промокоду"
                                register={register}
                            />
                        )
                    }
                </div>
                {
                    view?.role !== 'support' && (
                        <div style={{ display: 'flex', columnGap: 20 }}>
                            <FieldInput
                                name="utm_source"
                                placeholder="Поиск по utm_source"
                                register={register}
                            />
                            <FieldInput
                                name="utm_content"
                                placeholder="Поиск по utm_content"
                                register={register}
                            />
                            <FieldInput
                                name="utm_medium"
                                placeholder="Поиск по utm_medium"
                                register={register}
                            />
                            <FieldInput
                                name="utm_term"
                                placeholder="Поиск по utm_term"
                                register={register}
                            />
                            <FieldInput
                                name="utm_campaign"
                                placeholder="Поиск по utm_campaign"
                                register={register}
                            />
                        </div>
                    )
                }
                {
                    view?.role !== 'support' && (
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', columnGap: 20}}>
                                <FieldsDatePicker
                                    register={register}
                                    type="datetime-local"
                                    label="Период регистрации"
                                />
                                <FieldSelect
                                    register={register}
                                    label="Валюта"
                                    name="currency"
                                    list={CURRENCY_LIST}
                                    defaultOption="Выбрать валюту"
                                />
                                <FieldSelect
                                    register={register}
                                    label="Группы"
                                    name="groups_cashiers"
                                    list={GROUPS_CASHIERS_LIST}
                                    defaultOption="Выбрать группу"
                                />
                            </div>
                            <div style={{ display: 'flex', columnGap: 94, alignItems: 'center' }}>
                                <CheckboxSwitch
                                    register={register}
                                    control={control}
                                    name="is_deposit"
                                    label="Имеются депозиты"
                                />
                                <div style={{display: 'flex', columnGap: 20}}>
                                    {
                                        is_deposit && (
                                            <FieldInput
                                                name="count_deposit"
                                                type="number"
                                                placeholder="Кол-во депозитов от"
                                                register={register}
                                            />
                                        )
                                    }
                                    {
                                        is_deposit && (
                                            <FieldInput
                                                name="sum_deposit"
                                                type="number"
                                                placeholder="Сумма депозитов от"
                                                register={register}
                                            />
                                        )
                                    }
                                </div>
                            </div>

                        </div>
                    )}

                <div style={{ display: 'flex', columnGap: 10, alignItems: 'center' }}>
                    <button type="submit" style={{
                        color: '#141b33',
                        cursor: 'pointer',
                        padding: '10px 20px',
                        background: '#ffc324',
                        borderRadius: '4px',
                        border: 'none',
                        outline: 'none'
                    }}>Поиск</button>
                    {
                        view?.role !== 'support' && (
                            <div onClick={() => {
                                dispatch(setGetUsersInCsv({
                                    login,
                                    stream,
                                    email,
                                    phone,
                                    referral: referral?.toLowerCase(),
                                    count_deposit,
                                    sum_deposit
                                }))
                            }} style={{
                                color: '#141b33',
                                cursor: 'pointer',
                                padding: '10px 20px',
                                background: '#ffc324',
                                borderRadius: '4px',
                                border: 'none',
                                outline: 'none'
                            }}>
                                <span>CSV</span>
                            </div>
                        )
                    }
                </div>

            </form>
            <div className={classes.wrapBlock}>
                <TableCasino
                    route="/gamer/list/"
                    pagination
                    allPage={users.countPage}
                    width={"100%"}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    orderByDefault="id,desc"
                    order={(v) => {
                        setValue(`orderBy`, `${v.id},${v.sort}`);
                        dispatch(setGetUsers({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            login,
                            stream,
                            email,
                            phone,
                            count_deposit,
                            sum_deposit,
                            from_date,
                            to_date,
                            utm_source, 
                            utm_content, 
                            utm_medium, 
                            utm_term,
                            utm_campaign, 
                            currency, 
                            groups_cashiers,
                            orderBy: `${v.id},${v.sort}`
                        }))
                    }}
                    changePage={(v) => {
                        if (users.countPage > 1) {
                            dispatch(setGetUsers({
                                page: +v.page + 1,
                                rowsPerPage: v.rowsPerPage,
                                login,
                                stream,
                                email,
                                phone,
                                count_deposit,
                                sum_deposit,
                                from_date,
                                to_date,
                                utm_source, 
                                utm_content, 
                                utm_medium, 
                                utm_term,
                                utm_campaign, 
                                currency, 
                                groups_cashiers,
                                orderBy
                            }))
                        }
                    }}
                    changeRowsPerPage={(v) => {
                        if (users.countPage > 1) {
                            reset({
                                stream: '',
                                login: '',
                                phone: '',
                                email: '',
                                referral: '',
                                from_date: '',
                                to_date: '',
                                is_deposit: false,
                                count_deposit: '',
                                sum_deposit: '',
                                utm_source: '',
                                utm_content: '',
                                utm_medium: '',
                                utm_term: '',
                                utm_campaign: '',
                                currency: '',
                                groups_cashiers: '',
                            })

                            dispatch(setGetUsers({
                                page: 1,
                                rowsPerPage: v.rowsPerPage,
                                orderBy
                            }))
                        }

                    }}
                />
            </div>
        </div>
    )
}

export default UserList;